import { Trans } from "../utils/i18n";
import React from "react";
import {Alert} from "@mui/material";


export const appointment = {
    "sizes": {
        "forth": 3,
        "third": 4,
        "half": 6,
        "full": 12
    },
    "heading": <Trans i18nKey="orderEntry.basicData">Basic data</Trans>,
    "groups": [
        {
            "heading": <Trans i18nKey="appointment.form.tid">TID</Trans>,
            "fields": [
                {
                    "size": "full",
                    "component": "terminalid"
                },
            ],
        },
        // {
        //     "heading": <Trans i18nKey="appointment.form.date">Date</Trans>,
        //     "description": <Trans i18nKey="appointment.form.date.description">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</Trans>,
        //     "fields": [
        //         {
        //             "name": "day",
        //             "label": <Trans i18nKey="appointment.form.day">Day</Trans>,
        //             "size": "half",
        //             "type": "datepicker",
        //             "required": true,
        //             "preventWeekends": true,
        //         },
        //     ],
        //     "conditionFunction": (values, orderEntryState) => {
        //         const request = orderEntryState?.requesttypes?.find(type => type.key === values.appointmentGroup)
        //         return request?.type === 'appointment_walkin' ? !!values.appointmentGroup && !!values.partner_id : !!values.appointmentGroup
        //     }
        // },
        {
            "heading": <Trans i18nKey="appointment.form.appointments">Appointments</Trans>,
            "description": <Trans i18nKey="appointment.form.appointments.description">First, please choose an available day from the calendar. After that, you can select the time for your appointment.</Trans>,
            "fields": [
                {
                    "size": "full",
                    "component": "timeslots"
                }
            ],
            "conditionFunction": (values, orderEntryState) => orderEntryState.terminalId?.success,
        },
        {
            "heading": <Trans i18nKey="appointment.form.contact">Contact</Trans>,
            "description": <Trans i18nKey="appointment.form.contact.description">Please check and update your contact information</Trans>,
            "fields": [
                {
                    "name": "name",
                    "label": <Trans i18nKey="queues.company">Company</Trans>,
                    "placeholder": <Trans i18nKey="queues.company">Company</Trans>,
                    "size": "full",
                    "type": "text",
                    "required": true,
                },
                {
                    "name": "name_2",
                    "label": <Trans i18nKey="orderEntry.addressContact.contact_name">Contact name</Trans>,
                    "placeholder": <Trans i18nKey="orderEntry.addressContact.contact_name">Contact name</Trans>,
                    "size": "full",
                    "type": "text",
                    "required": true,
                },
                {
                    "name": "phone",
                    "label": <Trans i18nKey="orderEntry.addressContact.phone">Phone</Trans>,
                    "placeholder": <Trans i18nKey="orderEntry.addressContact.phoneNumber">Phone number</Trans>,
                    "size": "half",
                    "type": "phoneinput",
                    "required": true,
                },
                {
                    "name": "email",
                    "label": <Trans i18nKey="appointment.form.email">E-Mail Address</Trans>,
                    "placeholder": <Trans i18nKey="appointment.form.email">E-Mail Address</Trans>,
                    "size": "half",
                    "type": "email",
                    "required": true,
                },
            ],
            "conditionFunction": (values, orderEntryState) => orderEntryState.terminalId?.success && values.timeslot_id,
        },

        {
            "heading": <Trans i18nKey="appointments.cashRegisterConnection">Cash register connection</Trans>,
            "description": <Trans i18nKey="appointment.cashRegisterConnection.description">Does your terminal require a cash register connection?</Trans>,
            "conditionFunction": (values, orderEntryState) => orderEntryState.terminalId?.success && values.timeslot_id,
            "fields": [
                {
                    "name": "cash_register_connection",
                    "size": "half",
                    "titel": <Trans i18nKey="appointments.cashRegisterConnection.yes">Yes, a cash register connection is required</Trans>,
                    "type": "radiobig",
                    "value": "yes",
                    "required": true,
                },
                {
                    "name": "cash_register_connection",
                    "size": "half",
                    "titel": <Trans i18nKey="appointments.cashRegisterConnection.no">No, not required</Trans>,
                    "type": "radiobig",
                    "value": "no",
                    "required": true,
                },
                {
                    "id": "cashRegisterConnectionInfo",
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <div>
                        <Alert severity="warning">
                            <span className={'mb-1 block font-medium'}>
                                <Trans i18nKey="appointments.cashRegisterConnection.h1">The following infos are required from your side for the appointment:</Trans>
                            </span>
                            <Trans i18nKey="appointments.cashRegisterConnection.span1">
                                Connection type: <b>network (WLAN, LAN)</b> or <b>serial cable</b>
                            </Trans><br/>
                            <Trans i18nKey="appointments.cashRegisterConnection.span2">
                                For the network variant, a <b>fixed IP address</b>, <b>subnet
                                mask</b> and <b>gateway</b> are required for the card reader.
                            </Trans><br/>
                            <Trans i18nKey="appointments.cashRegisterConnection.span3">
                                Cash register interface: <b>ZVT</b> or <b>OPI</b>, as well as the associated port/s
                            </Trans>
                        </Alert>
                    </div>,
                    "conditionFunction": (values, orderEntryState) => orderEntryState.terminalId?.success && values.timeslot_id && values.cash_register_connection === 'yes',
                },
            ],
        },
        {
            "fields": [
                {
                    "name": "terms_of_service",
                    "label": <Trans i18nKey="appointment.privacy.label">I have read and accept the <a href={'https://www.unzer.com/de/datenschutz/#footer-section'} target={'_blank'}>Privacy Statement</a></Trans>,
                    "size": "full",
                    "type": "checkbox",
                    "required": true
                }
            ],
            "conditionFunction": (values, orderEntryState) => orderEntryState.terminalId?.success && values.timeslot_id && values.cash_register_connection,
        },
    ],
    "actions": [
        {
            "fields": [
                {
                    "text": <Trans i18nKey="appointment.send">Send</Trans>,
                    "size": "half",
                    "component": "button",
                    "action": "next",
                    "color": "secondary",
                    "conditionFunction": (values, orderEntryState) => orderEntryState.terminalId?.success && values.timeslot_id && values.cash_register_connection,
                }
            ]
        }
    ]
}
